// extracted by mini-css-extract-plugin
module.exports = {"popup":"_2mCZU","close":"W6a8V","open":"_2eusz"};